const translations = {
  'spanishCourse.seo.title': 'Intensive Spanish Courses for TEFL Teachers in Barcelona',
  'spanishCourse.seo.description':
    'Spanish courses designed for new teachers in Barcelona. Kickstart your Spanish by studying with our experienced teachers. ',
};

export default translations;
